export class Section {
  name: string;
  description: string;
  icon: string;
  url: string;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/models/section.model.ts